<template>
  <div class="bloc-info">
    <div
      class="bloc-info-ur"
      :class="blocInfoUr ? 'bloc-info-ur-selected' : 'bloc-info-ur-unselected'"
    >
      <div
        class="bloc-info-header-ur"
        :class="
          blocInfoUr
            ? 'bloc-info-header-ur-selected'
            : 'bloc-info-header-ur-unselected'
        "
        @click="
          blocInfoUr = !blocInfoUr;
          blocInfoIP = false;
        "
      >
        Если вы представляете юридическое лицо
      </div>
      <div class="bloc-info-body-ur" v-if="blocInfoUr">
        <p>
          1. Информацию о юридическом лице (сайт, телефон, адрес электронной
          почты, адреса, численность, коды статистики, иное);
        </p>
        <p>
          2. Информацию о финансово-хозяйственной деятельности юридического лица
          (фактический вид деятельности, плательщики, получатели,
          банки-контрагенты, иное);
        </p>
        <p>
          3. Информацию о представителе, участниках, бенефициарах,
          выгодоприобретателях (при наличии) (ИНН, паспортные данные, телефон,
          адрес электронной почты, СНИЛС, адреса, ОГРН, иное);
        </p>
        <p>
          4. Электронные копии документов для прикрепления к анкете:
        </p>

        <dl>
          <dt class="bold-text">Обязательные:</dt>
          <dd>- <span class="bold-text">устав</span>;</dd>
          <dd>
            - учредительный договор (только для хозяйственных товариществ);
          </dd>
          <dd>
            -
            <span class="bold-text">решение или протокол об избрании</span>
            единоличного исполнительного органа;
          </dd>
          <dd>
            -
            <span class="bold-text">документы, подтверждающие полномочия</span>
            единоличного исполнительного органа (кадровый приказ или трудовой
            договор);
          </dd>
          <dd>
            -
            <span class="bold-text">документ, удостоверяющий личность</span>
            единоличного исполнительного органа;
          </dd>
          <dd>
            - <span class="bold-text">выписка из реестра</span> акционеров /
            реестр акционеров (для акционерных обществ) с актуальными
            сведениями;
          </dd>
          <dd>
            - документ, подтверждающий
            <span class="bold-text">финансовое положение</span> (годовая
            бухгалтерская отчетность
            <span class="bold-text">или</span> налоговая декларация или
            аудиторское заключение <span class="bold-text">или</span> иной
            документ, необходимый для подтверждения финансового положения);
          </dd>
          <dd>
            - документ, подтверждающий
            <span class="bold-text">деловую репутацию</span> (отзыв
            <span class="bold-text">или</span> рекомендация
            <span class="bold-text">или</span> гарантийное письмо
            <span class="bold-text">или</span> документ в свободной форме,
            содержащий ссылки на сайты, статьи, рейтинги, иное);
          </dd>
          <dd>
            - документы, подтверждающие
            <span class="bold-text">местоположение юридического лица</span>, его
            постоянно действующего органа (договор аренды
            <span class="bold-text">или</span>
            свидетельство на право собственности);
          </dd>
          <dd>
            - документ, подтверждающий право на использование дополнительных
            офисов, заводских, складских и других подсобных помещений (при
            наличии таких помещений).
          </dd>
          <dt class="bold-text">При наличии:</dt>
          <dd>- документы об обособленном подразделении;</dd>
          <dd>
            - документ, подтверждающий наличие и состав органов управления;
          </dd>
          <dd>
            - документы, подтверждающие наличие лиц (кроме единоличного
            исполнительного органа), уполномоченных распоряжаться денежными
            средствами, находящимися на счете;
          </dd>
          <dd>- лицензии, не включенные в ЕГРЮЛ (ЕГРИП);</dd>
          <dd>- выписка по счету в другом Банке за год;</dd>
          <dd>- выписка по 51 счету за год;</dd>
          <dd>
            - документ, удостоверяющий личность каждого бенефициарного
            владельца;
          </dd>
          <dd>- свидетельство о регистрации до 1 июля 2002 года.</dd>
        </dl>
        <p></p>
      </div>
    </div>
    <div
      class="bloc-info-ip"
      :class="blocInfoIP ? 'bloc-info-ur-selected' : 'bloc-info-ur-unselected'"
    >
      <div
        class="bloc-info-header-ip"
        :class="
          blocInfoIP
            ? 'bloc-info-header-ip-selected'
            : 'bloc-info-header-ip-unselected'
        "
        @click="
          blocInfoIP = !blocInfoIP;
          blocInfoUr = false;
        "
      >
        Если вы являетесь индивидуальным предпринимателем
      </div>
      <div class="bloc-info-body-ip" v-if="blocInfoIP">
        <p>
          1. Информацию об индивидуальном предпринимателе (ИНН, ОГРНИП,
          паспортные данные, сайт, телефон, адрес электронной почты, адреса,
          численность, коды статистики, СНИЛС, адреса, иное);
        </p>
        <p>
          2. Информацию о финансово-хозяйственной деятельности индивидуального
          предпринимателя (фактический вид деятельности, плательщики,
          получатели, банки-контрагенты, иное);
        </p>
        <p>
          3. Информацию о бенефициарах (при наличии), выгодоприобретателях (при
          наличии) (ИНН, паспортные данные, телефон, адрес электронной почты,
          СНИЛС, адреса, иное);
        </p>
        <p>
          4. Электронные копии документов для прикрепления к анкете:
        </p>
        <dl>
          <dt class="bold-text">Обязательные:</dt>
          <dd>
            -
            <span class="bold-text">документ, удостоверяющий личность</span>
            индивидуального предпринимателя;
          </dd>
          <dd>
            - документ, подтверждающий
            <span class="bold-text">финансовое положение</span> (годовая
            бухгалтерская отчетность
            <span class="bold-text">или</span> налоговая декларация или
            аудиторское заключение <span class="bold-text">или</span> иной
            документ , необходимый для подтверждения финансового положения);
          </dd>
          <dd>
            - документ, подтверждающий
            <span class="bold-text">деловую репутацию</span> (отзыв
            <span class="bold-text">или</span> рекомендация
            <span class="bold-text">или</span> гарантийное письмо
            <span class="bold-text">или</span> документ в свободной форме,
            содержащий ссылки на сайты, статьи, рейтинги, иное).
          </dd>
          <dt class="bold-text">При наличии:</dt>
          <dd>
            - документы, подтверждающие наличие лиц (кроме индивидуального
            предпринимателя), уполномоченных распоряжаться денежными средствами,
            находящимися на счете;
          </dd>
          <dd>- лицензии, не включенные в ЕГРЮЛ (ЕГРИП);</dd>
          <dd>- выписка по счету в другом Банке за год;</dd>
          <dd>- выписка по 51 счету за год;</dd>
          <dd>
            - документ, удостоверяющий личность каждого бенефициарного
            владельца;
          </dd>
          <dd>
            - документ, удостоверяющий личность лиц, указанных в карточке с
            образцами подписи и оттиска печати;
          </dd>
          <dd>- свидетельство о регистрации до 1 января 2004 года.</dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InputInnInfo",
  data() {
    return {
      blocInfoUr: false,
      blocInfoIP: false,
    };
  },
};
</script>

<style scoped>
dt {
  margin-left: 10px;
}
.bloc-info {
  width: auto;
}
.bloc-info-ur,
.bloc-info-ip {
  max-width: 600px;
  margin-top: 5px;
  margin-left: auto;
  margin-right: auto;
}
.bloc-info-ur-selected,
.bloc-info-ip-selected {
  border-radius: 5px;
  border: 1px solid #06569b;
}
.bloc-info-header-ur,
.bloc-info-header-ip {
  cursor: pointer;
  padding: 5px 10px;
}
.bloc-info-header-ur-unselected,
.bloc-info-header-ip-unselected {
  border: 1px solid #06569b;
  border-radius: 5px;
}
.bloc-info-header-ur-selected,
.bloc-info-header-ip-selected {
  border-bottom: 1px solid #06569b;
  border-radius: 0px;
}
.bloc-info-header-ur:hover,
.bloc-info-header-ip:hover {
  background-color: #06569b;
  color: white;
}
.bloc-info-body-ur,
.bloc-info-body-ip {
  text-align: left;
  padding: 0px 5px;
}
</style>
